// keep track of state
// null values will get set at runtime

let ref = {
    viewport: {
        viewportLarge: null,
        viewportBlockWidth: null,
        viewportBlockHeight: null
    },
    data: null, 
    dom: null, // d3 selection
    uniNames: [],
    activeIndex: 0,
    activeChart: 'salary',
    highlightColour: null,
    minMaxValues: {
        vc_pay: [],
        average_pay: [],
        ref: [],
        nss: [],
        students: []
    }
};

export default ref;